import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import DateFilter from '@/components/DateFilter.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import BranchesFilter from "@/components/BranchesFilter.vue";
import { modalMixins } from '@/mixins/modal.js';
import mobileFiltersModal from "@/components/mobileFiltersModal.vue";
let Reports = class Reports extends Vue {
    user = [];
    branchesId = [];
    dates = {};
    get mapping() {
        const mapping = {
            'reports.summary': {
                label: 'Summary',
                icon: 'fe-home'
            },
            'reports.payments': {
                label: 'Payments',
                icon: 'fe-credit-card'
            },
            'reports.payouts': {
                label: 'Payouts',
                icon: 'fe-send'
            },
            'reports.history': {
                label: 'History',
                icon: 'fe-file-text'
            },
            'reports.customers': {
                label: 'Customers',
                icon: 'fe-users',
            },
            'reports.appointments': {
                label: 'Appointments',
                icon: 'fe-calendar'
            },
            'reports.services': {
                label: 'Services',
                icon: 'fe-sliders'
            },
            'reports.products': {
                label: 'Products',
                icon: 'fe-package'
            },
            'reports.toppers': {
                label: 'Toppers',
                icon: 'fe-trending-up'
            },
            'reports.expenses': {
                label: 'Expenses',
                icon: 'fe-dollar-sign'
            },
        };
        if (!this.$hasPermission('payment-reports', ['seeAll']) || !this.$loadModule('billing')) {
            delete mapping['reports.payments'];
        }
        if (!this.$hasPermission('sales-reports', ['seeAll']) || !this.$loadModule('billing')) {
            delete mapping['reports.payouts'];
        }
        if (!this.$loadModule('billing')) {
            delete mapping['reports.history'];
        }
        if (!this.$hasPermission('expense', ['create']) || !this.$loadModule('billing')) {
            delete mapping['reports.expenses'];
        }
        return mapping;
    }
    get tab() {
        if (!this.$route.name)
            return '';
        return this.mapping[this.$route.name].label;
    }
};
Reports = __decorate([
    Component({
        mixins: [modalMixins],
        components: {
            DateFilter,
            TeamFilter,
            BranchesFilter,
            mobileFiltersModal
        }
    })
], Reports);
export default Reports;
